<template>
  <!-- 커스텀 검색 기능 -->
  <div class="customSearch">
    <!-- 자주묻는 질문 결과 -->
    <section class="TEXT" v-if="scenarioContent.buttons || !scenarioContent.parentCode">
      <template v-if="scenarioContent.textContent">
        <h2 class="title" v-if="scenarioContent.textContent.title">{{ scenarioContent.textContent.title }}</h2>
        <p class="txt message-content-wrap">{{ scenarioContent.textContent.description }}</p>
      </template>
      <template v-else>
        <h2 class="title" v-if="scenarioContent.title">{{ scenarioContent.title }}</h2>
        <p class="txt message-content-wrap">{{ scenarioContent.description }}</p>
      </template>
      <p class="txt" v-if="scenarioContent.text" :style="{ paddingTop: scenarioContent.buttons ? '5px' : '0' }" v-html="scenarioContent.text"></p>
      <div v-if="scenarioContent.buttons && scenarioContent.buttons.length > 0">
        <div class="btns">
          <div v-for="(item, idx) in scenarioContent.buttons" :key="idx" @click="sendSearch(item, messageType, 'RESULT')">
            <a class="result-btns" :class="{ on: scenarioData[chatIndex] === item.code }"> {{ item.text }} </a>
          </div>
        </div>
      </div>
      <div v-show="hasCounselorButton(scenarioContent.buttons).length > 0">
        <CounselorButtons :counselorButtons="scenarioContent.buttons" :messageType="messageType" :clickedCategory="clickedCategory" :chat="chat" />
      </div>
    </section>

    <!-- 검색창 -->
    <section class="TEXT" v-else>
      <dl>
        <dt class="title">검색으로 질문하기</dt>
        <dd class="txt message-content-wrap">
          찾는 항목이 없으신가요?<br />
          궁금한 점을 저에게 말씀해주세요.
        </dd>
      </dl>
      <div class="btns">
        <div class="searchInput" :class="searchTextFocus && 'active'">
          <div class="searchIcon" @click="searchAction" v-show="searchTextWrtie" />
          <div class="s-input__slot">
            <input
              v-model="searchText"
              :class="isPreview(chatRoomId) && 'readonly'"
              :readonly="isPreview(chatRoomId) && 'readonly'"
              maxlength="100"
              type="text"
              placeholder="내용을 입력해주세요."
              @keyup="setSearchTextWrite()"
              @focus="setSearchTextFocus(true)"
              @blur="setSearchTextFocus(false)"
              @keypress.enter="searchAction"
            />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import CounselorButtons from './CounselorButtons';
import { searchActionHelper, searchLayoutHelper } from '@/components/mixin/custom/search';

export default {
  name: 'ScenarioList',
  props: {
    senderUid: {
      type: String,
      require: false
    },
    chatRoomId: {
      type: Number,
      require: false
    },
    chatIndex: {
      type: Number,
      required: true
    },
    chat: {
      type: Object,
      require: true
    },
    scenarioData: {
      type: Object,
      require: true
    },
    clickedCategory: {
      type: Function,
      require: true
    }
  },
  mixins: [searchActionHelper, searchLayoutHelper],
  components: {
    CounselorButtons
  },
  created() {
    this.scenarioContent = JSON.parse(this.chat.content);
  },
  mounted() {
    this.$emit('setFaq', true);
  },
  methods: {
    hasCounselorButton(buttons) {
      return buttons ? buttons.filter((b) => b.type === 'COUNSELOR_BUTTON') : 0;
    }
  }
};
</script>

<style lang="scss">
/* 커스텀 검색 기능 */
.customSearch {
  .TEXT {
    .title {
      font-size: 16px;
    }
    .txt {
      line-height: 20px;
    }
    .message-content-wrap {
      white-space: pre-line;
      word-break: break-all;
    }

    .searchInput {
      position: relative;
      .s-input__slot {
        min-height: 35px;
        border: 1px solid #bebebe;
        border-radius: 3px;
        input {
          line-height: 20px;
          width: 100%;
          padding: 7.5px;
          font-size: 14px;
          padding-right: 34px;
          border: 0;
          background-color: rgba(0, 0, 0, 0);
        }
      }
      &.active {
        .s-input__slot {
          border: 1px solid #5578f0;
          .readonly {
            &:focus {
              outline: none;
              border: 0;
            }
          }
        }
        .searchIcon {
          &::before {
            color: #5578f0;
          }
        }
      }
      .searchIcon {
        &::before {
          content: '\e91b';
        }
        position: absolute;
        top: 50%;
        right: 0;
        transform: translate(0%, -50%);
        font-family: twc;
        font-size: 24px;
        color: #919191;
        cursor: pointer;
        padding: 0 8px 0 8px;
      }
    }

    .btns {
      .result-btns {
        padding: 0 12px 0 12px;
      }
    }
  }
}
.msgList {
  .systemBox.searchMargin {
    margin-top: -12px;
  }
}
</style>
